import React from 'react'
import {DateTime} from 'luxon'
import BoxAtom from '../../@atoms/to_layout/box/box.atom'
import ButtonTimeslotAtom from '../../@atoms/to_forms/button_timeslot/button_timeslot_atom'
import ButtonCalendarAtom from '../../@atoms/to_forms/button_calendar/button_calendar.atom'
import ButtonPrevnextAtom from '../../@atoms/to_forms/button_prevnext/button_prevnext.atom'
import DateNavChoiceAtom from '../../@atoms/to_forms/date_navchoice/date_navchoice.atom'
import DateSelectionModalHeaderComponent from '../date_selection_modal_header/date_selection_modal_header.component'
import DateTimeChoiceWrapperAtom from '../../@atoms/to_layout/date_time_choice_wrapper/date_time_choice_wrapper.atom'
import DateSelectionActionBtnComponent from '../date_selection_action_btn/date_selection_action_btn.component'
import ModalErrorAtom from '../../@atoms/to_content/modal_error/modal_error.atom'
import SkeletonAtom from '../../@atoms/to_layout/skeleton/skeleton.atom'
import SvgIconAtom from '../../@atoms/to_content/svg_icon/svg_icon.atom'
import StandardDateChoiceWrapperAtom from '../../@atoms/to_content/standard_date_choice_wrapper/standard_date_choice_wrapper.atom'
import TypographyAtom from '../../@atoms/to_content/typography/typography.atom'
import utils from '../../utils'
import useStandardDateChoice from '../../@hooks/use_standard_date_choice'

interface WeekNavigationProps {
  startDate: DateTime | null
  weekPrevFn: (arg: DateTime) => void
  weekNextFn: (arg: DateTime) => void
  disablePrev: boolean
}

const WeekNavigation: React.FC<WeekNavigationProps> = function ({
  startDate,
  weekPrevFn,
  weekNextFn,
  disablePrev,
}) {
  if (!startDate) return null

  return (
    <BoxAtom className="calender-nav-header-wrapper">
      <ButtonPrevnextAtom
        disabled={disablePrev}
        ap_type="prev"
        onClick={() => !disablePrev && weekPrevFn(startDate)}
      />
      <div>
        <TypographyAtom ahd_type="subheading">
          <span>{`${startDate.day} ${startDate.monthShort}`}</span>
          <span className="gap">-</span>
          <span>{`${startDate.plus({day: 6}).day} ${
            startDate.plus({day: 6}).monthShort
          }`}</span>
        </TypographyAtom>
      </div>
      <ButtonPrevnextAtom
        ap_type="next"
        onClick={() => weekNextFn(startDate)}
      />
    </BoxAtom>
  )
}

// default module
const StandardDateChoiceComponent: React.FC = function () {
  const {
    labels,
    selectedDate,
    loading,
    error,
    startDate,
    weekNextFn,
    weekPrevFn,
    buttonTimeslotAtomRef,
    buttonCalenderAtomRef,
    dateSlots,
    selectedSlot,
    setSelectedSlot,
    calenderDateList,
    handleCalenderChangeEvent,
    setError,
    getBookVisitPayload,
    disablePrev,
  } = useStandardDateChoice()

  const ModalBody =
    dateSlots.length && !loading ? (
      <DateTimeChoiceWrapperAtom>
        <DateNavChoiceAtom>
          <WeekNavigation
            disablePrev={disablePrev}
            startDate={startDate}
            weekPrevFn={weekPrevFn}
            weekNextFn={weekNextFn}
          />
          <ButtonCalendarAtom
            ref={buttonCalenderAtomRef}
            ap_calen_arr={calenderDateList}
            setCalenderDate={handleCalenderChangeEvent}
          />
          <ButtonTimeslotAtom
            ref={buttonTimeslotAtomRef}
            ap_data_arr={utils.getDateSlots(selectedDate || '', dateSlots)}
            setSelectedSlot={setSelectedSlot}
          />
          <BoxAtom className="eco-description">
            <SvgIconAtom ap_type="greenLeaf" ap_color="inherit" width="24" />
            <TypographyAtom ahd_type="step">
              {labels.bookDateModal.footerNote}
            </TypographyAtom>
          </BoxAtom>
          <DateSelectionActionBtnComponent
            setError={setError}
            btnDisabled={selectedSlot === null}
            getBookVisitPayload={getBookVisitPayload}
          />
        </DateNavChoiceAtom>
      </DateTimeChoiceWrapperAtom>
    ) : (
      <SkeletonAtom ap_type="best_date_skeleton" />
    )

  return (
    <StandardDateChoiceWrapperAtom>
      <DateSelectionModalHeaderComponent />
      {!error.isError ? (
        ModalBody
      ) : (
        <ModalErrorAtom
          btnLabel={labels.bookDateModal.buttonForErrorClose}
          errorMsg={error.errorMsg}
        />
      )}
    </StandardDateChoiceWrapperAtom>
  )
}

export default StandardDateChoiceComponent
